import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const PayableIntegrationService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  service.getPayablesByCustomerId = (searchFields) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(searchFields);
    return axios.get(`${BASE_URL}/payable-account/search${queryString}`, {
      headers,
    });
  };

  service.getPayablesBySearchFields = (searchFields) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(searchFields);
    return axios.get(`${BASE_URL}/payables/search${queryString}`, {
      headers,
    });
  };

  service.getPISServiceOfferings = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/pis-offerings`, {
      headers,
    });
  };

  return service;
})();

export default PayableIntegrationService;
